import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"

export default function Product({ product }) {
    const handle = product.url.split("/products/").pop();

    return (
        <SerpElement
            as="nosto-dynamic-card"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            handle={handle} 
            template="block"
            variant-id={product?.skus?.[0]?.id}
        >
            <div class="product-card-skeleton"></div>
        </SerpElement>
    )
}
